module.exports = __webpack_public_path__ + "static/img/企业合规官.45329193.png";